export type UserDto = {
  firstName?: string;
  lastName?: string;
  email: string;
  phone?: string;
  profilePictureUrl?: string;
  jobTitle?: string;
  tenantOf?: string[] | null;
  accounts: { roles: UserAccountRoles[] }[];
  primaryAccountLocationId: string;
};

export enum UserAccountRoles {
  DecisionMaker = 'Decision Maker',
  Member = 'Member',
  Guest = 'Guest',
  Billing = 'Billing',
}
